
const columns = () => {
    return [
        {
            title: '组织名称',
            name: 'name',
            tableItem: {
                width: '320px'
            },
            searchItem: {}
        },
        {
            title: '组织编码',
            name: 'code',
            tableItem: {
                width: '255px'
            },
            searchItem: {}
        },
        {
            title: '组织类型',
            name: 'organizationNodeCategoryName',
            tableItem: {
                width: '200px'
            },
          searchItem: {}
        },
        {
            title: '组织状态',
            name: 'state',
            dict: [
                { code: 1, codeName: '有效' },
                { code: 0, codeName: '无效' },
            ],
            tableItem: {
                width: 100
            }
        }
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'organization/getOrganizationPageByUser',
        ...api
    }
}

const organizationByUser = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        rowkey: 'id',
        columns: columns(),
        tableApi: tableApi(api)
    }
}

export default organizationByUser
